import React, { useState, useEffect, Fragment } from 'react'
import 'moment/locale/th'
import { Modal, Badge, Row, Col, Form } from 'react-bootstrap'
import CONSTANTS from '../../constants/constants'
import callApi from '../../helpers/callapi'
import moment from 'moment'
import { useSelector } from 'react-redux'

const BANK = CONSTANTS.banks
const AGENT_TYPES = CONSTANTS.agentTypes

moment.locale('th')
const ModalEditDetail = (props) => {
  const { showEditDetail, setShowEditDetail, targetAgent, onClose, fetchAgents } = props
  const [loading, setLoading] = useState(false)
  const me = useSelector((state) => state.user)

  const [agent, setAgent] = useState(targetAgent)
  const [errors, setErrors] = useState({})

  const onAgentChange = (e) => {
    setAgent({
      ...agent,
      [e.target.name]: e.target.value,
    })
    setErrors({ ...errors, [e.target.name]: false })
  }

  useEffect(() => {
    setAgent(targetAgent)
  }, [targetAgent])

  const editAgent = async () => {
    try {
      setLoading(true)

      await callApi({
        url: `/agents/${agent.id}`,
        method: 'put',
        body: { ...agent },
      })

      setLoading(false)
      setShowEditDetail(false)
      onClose()
      // fetchOrders(currentPage);
      fetchAgents()
    } catch (error) {
      console.error('Error while trying to fetch orders.', error)
      alert(error)
      setLoading(false)
    }
  }

  return (
    <Fragment>
      <Modal show={showEditDetail} size="lg">
        <Modal.Header>แก้ไข</Modal.Header>
        <Modal.Body>
          <Row>
            <Col>ชื่อ</Col>
            <Col>
              <Form.Control
                name="firstName"
                type="text"
                placeholder="เลขบัญชี"
                onChange={onAgentChange}
                defaultValue={agent.firstName}
              />
            </Col>
          </Row>
          <Row>
            <Col>นามสกุล</Col>
            <Col>
              <Form.Control
                name="lastName"
                type="text"
                placeholder="เลขบัญชี"
                onChange={onAgentChange}
                defaultValue={agent.lastName}
              />
            </Col>
          </Row>
          <Row>
            <Col>ธนาคาร</Col>
            <Col>
              <Form.Control
                as="select"
                className="form-control"
                onChange={(value) =>
                  onAgentChange({
                    target: { value: value.target.value, name: 'bankName' },
                  })
                }
              >
                {Object.keys(BANK).map((key, i) => {
                  return (
                    <option value={key} key={i}>
                      {BANK[key]}
                    </option>
                  )
                })}
              </Form.Control>
            </Col>
          </Row>
          <Row>
            <Col>เลขบัญชี</Col>
            <Col>
              <Form.Control
                name="bankAccount"
                type="text"
                placeholder="เลขบัญชี"
                onChange={onAgentChange}
                defaultValue={agent.bankAccount}
              />
            </Col>
          </Row>
          <Row>
            <Col>ประเภทตัวแทน</Col>
            <Col>
              <Form.Control
                as="select"
                className="form-control"
                onChange={(value) =>
                  onAgentChange({
                    target: { value: value.target.value, name: 'type' },
                  })
                }
              >
                {AGENT_TYPES.map((item, i) => {
                  return (
                    <option key={i} value={item.value}>
                      {item.label}
                    </option>
                  )
                })}
              </Form.Control>
            </Col>
          </Row>
          <Row>
            <Col>ค่าคอมตัวแทน</Col>
            <Col>
              <Form.Control
                name="commission"
                type="text"
                placeholder="ค่าคอมตัวแทน"
                onChange={onAgentChange}
                defaultValue={agent.commission}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Badge variant="danger light" style={{ cursor: 'pointer' }} onClick={() => setShowEditDetail(false)}>
            ยกเลิก
          </Badge>
          <Badge variant="primary light" style={{ cursor: 'pointer' }} onClick={() => editAgent()}>
            แก้ไข
          </Badge>
        </Modal.Footer>
      </Modal>
    </Fragment>
  )
}
export default ModalEditDetail
